module.exports = {"Description":"GS : SIQQ 1ZZ","RedundantCharacters":" -","ValidationRegex":"^SIQQ1ZZ$","TestData":{"Valid":["SIQQ 1ZZ","SIqq 1zz","SIQQ1ZZ"],"Invalid":["SIQQ01ZZ","SIQQ1ZZZ"]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/postal-codes-js/formats/GS.json
// module id = 4459
// module chunks = 11